import type { PlaceGeom } from '~/hooks/apis/search/useGetPlaces';

import type { SearchReproductionEntity } from '~/services/ReproduceSearchService';

import { isGoogleBoundsUrlValue } from '~/utils/lePlaceId';

export function entityToPointPlace(entity: SearchReproductionEntity, type: string): PlaceGeom | null {
  if (!entity.location) {
    return null;
  }

  const { latitude, longitude } = entity.location;

  return {
    placeId: entity.id,
    name: entity.name,
    type,
    geom: {
      type: 'Point',
      coordinates: [longitude, latitude],
    },
  };
}

export function buildPropertyMapPlaces(properties: Array<SearchReproductionEntity>): Array<PlaceGeom> {
  return properties.flatMap((property) => {
    const place = entityToPointPlace(property, 'property');
    return place ? [place] : [];
  });
}

export function buildEntityFallbackPlaces(
  entities: Array<SearchReproductionEntity>,
  resolvedPlaceIds: Set<string> | Array<string>,
): Array<PlaceGeom> {
  const resolvedIds = resolvedPlaceIds instanceof Set ? resolvedPlaceIds : new Set(resolvedPlaceIds);
  const seenIds = new Set<string>();

  return entities.flatMap((entity) => {
    if (!entity.location || resolvedIds.has(entity.id) || isGoogleBoundsUrlValue(entity.id) || seenIds.has(entity.id)) {
      return [];
    }

    seenIds.add(entity.id);
    const place = entityToPointPlace(entity, 'entity_location');
    return place ? [place] : [];
  });
}
